import * as React from "react";
import {useSearchParams} from "react-router-dom";
import AreaContainer from "./AreaContainer";
import AreaList from "./AreaList";
import OrganizationManagement from "../organization/OrganizationManagement";
import OrganizationPlanManagement from "../organization/OrganizationPlanManagement";
import UserManagement from "../user/UserManagement";
import ContextWrapper from "../../components/context/ContextWrapper";
import {MapContextWrapper} from "../../components/context/MapContextWrapper";
import {UploadQueueProvider} from "../../components/uploadQueue/UploadQueueContext";

const AreaMain = () => {
    const [search] = useSearchParams();
    const areaID = search.get("areaID");
    const view = search.get("view");

    if (!areaID && view === "organizations") {
        return <OrganizationManagement/>;
    }
    if (!areaID && view === "plans") {
        return <OrganizationPlanManagement/>;
    }
    if (!areaID && view === "users") {
        return <UserManagement/>;
    }

    return areaID ?
        <MapContextWrapper>
            <ContextWrapper>
                <UploadQueueProvider>
                    <AreaContainer/>
                </UploadQueueProvider>
            </ContextWrapper>
        </MapContextWrapper>
        : <AreaList/>
};

export default AreaMain;
